/**
 * Reads JWT `exp` (Unix seconds) from a bearer token without verifying the signature.
 * Matches what the API gateway uses so client expiry aligns with server checks.
 */
export function readJwtPayloadExpSeconds(jwt: string | null | undefined): number | null {
  if (!jwt || typeof jwt !== 'string') {
    return null;
  }

  try {
    const segment = jwt.split('.')[1];
    if (!segment) {
      return null;
    }

    let b64 = segment.replaceAll('-', '+').replaceAll('_', '/');
    const pad = b64.length % 4;
    if (pad) {
      b64 += '='.repeat(4 - pad);
    }

    const payload = JSON.parse(atob(b64)) as { exp?: unknown };
    const exp = payload.exp;
    if (typeof exp !== 'number' || !Number.isFinite(exp)) {
      return null;
    }

    return exp;
  } catch {
    return null;
  }
}
